import { render, staticRenderFns } from "./OfficeHourManager.vue?vue&type=template&id=1212d3e2&scoped=true"
import script from "./OfficeHourManager.vue?vue&type=script&lang=js"
export * from "./OfficeHourManager.vue?vue&type=script&lang=js"
import style0 from "./OfficeHourManager.vue?vue&type=style&index=0&id=1212d3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1212d3e2",
  null
  
)

export default component.exports